module.exports = "/shiftTasks/components/taskInstances/taskInstancesList/taskInstanceListItemOptions-2f4f27.html";